import { PersonalInfo } from "./blocks";

const AccountUserProfileContent = () => {
  return (
    <div className="grid ">
      <div className="col-span-1">
        <div className="grid gap-5 lg:gap-7.5">
          <PersonalInfo />
        </div>
      </div>
    </div>
  );
};

export { AccountUserProfileContent };
